import { Box, Table, type TableProps } from '@mui/material';

/** mui-markdown's own scrollable-table wrapper, with bottom margin added; overriding
 * `table` without a `component` falls back to a bare native `<table>` with no styling. */
export function MarkdownTable({ children, sx, ...rest }: TableProps & { sx?: object }) {
    return (
        <Box sx={{ overflow: 'auto', mb: 1.5, ...sx }}>
            <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
                <Table {...rest}>{children}</Table>
            </Box>
        </Box>
    );
}
